/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './WithNavTemplate.style';

import SideBar from 'src/shared/app/base/component/aside/SideBar';
import MainSwitch from 'src/shared/app/base/component/switch/MainSwitch';
import MainNav from 'src/shared/app/nav/component/main/MainNav';

const useStyles = createUseStyles(styles);

const WithNavTemplate = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <SideBar layoutClass={classes.aside}>
        <MainNav />
      </SideBar>
      <MainSwitch layoutClass={classes.main} />
    </div>
  );
};

export default compose(React.memo)(WithNavTemplate);
